import Product from '../pages/Product';

export const CatalogV2Routes = [
  {
    path: '/v2/product/:id',
    isPrivate: true,
    component: <Product />,
  },
];
